import React from 'react'

// styles
import './index.scss'

const PageNotFound = () => {
  return (
    <div className="page-not-found ">
      <div className="container">
        <div className="height-10">
          <div className="content flex h-center">
            <h1>Page not found.</h1>
            <p className="para-margin">Page which you are looking is currently not available.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PageNotFound